import React from "react";
import MainMenu from "./MainMenu";
import KUGSPlayer from "./components/KUGSPlayer";
import { Image } from "react-bootstrap";
import kugs_logo_circle from "./images/kugs_logo_circle.png";
import "./style/header.scss";

function Header() {
  return (
    <div className="full-header">
      <header className="site-header">
        <div className="kugs-logo-container">
          <Image
            alt="KUGS logo"
            className="kugs-logo"
            src={kugs_logo_circle}
            width="256"
            height="256"
          />
        </div>
        <KUGSPlayer />

        <canvas id="canvas"></canvas>
        <nav className="nav--main" aria-label="Main">
          <MainMenu />
        </nav>
      </header>
    </div>
  );
}

export default Header;
